export const getCommentsDownloadData = (comments = []) => {
  return comments.map(comment => {
    const { comment_id, query, themes, ...rest } = comment;
    const queryText = query?.split("text=") || "";
    const themeText = Array.isArray(themes) ? themes.join(", ") : themes;
    return {
      ...rest,
      query: queryText[1],
      themes: themeText,
    };
  });
};

export const getValues = param => {
  return (param ?? "").split("_").filter(Boolean);
};

export const getCurrentUrlParams = () => {
  const currentParams = new URLSearchParams(window.location.search);
  const geoParam = currentParams.get("geo");
  const countryParam = currentParams.get("country");
  const divisionParam = currentParams.get("division");
  const mgmtLvlParam = currentParams.get("mgmtLvl");
  const l2mParam = currentParams.get("l2m");
  const l3mParam = currentParams.get("l3m");
  const favorabilityParam = currentParams.get("favorability");
  const questionParam = currentParams.get("question");
  const searchParam = currentParams.get("search");
  const datesParam = currentParams.get("dates");
  const sentimentParam = currentParams.get("sentiment");
  const tenureParam = currentParams.get("tenure");
  return {
    dates: getValues(datesParam),
    favorability: getValues(favorabilityParam),
    question: getValues(questionParam),
    geo: getValues(geoParam),
    country: getValues(countryParam),
    division: getValues(divisionParam),
    mgmtLvl: getValues(mgmtLvlParam),
    l2m: getValues(l2mParam),
    l3m: getValues(l3mParam),
    sentiment: getValues(sentimentParam),
    tenure: getValues(tenureParam),
    ...(searchParam ? { text: searchParam } : {}),
  };
}; 
